export const en = {
  'addme-button-text': 'Add yourself',
  'add-participants-from-event-button-text': 'Add attendees from event'
};
